import { useMemo } from "react";
import useThemeStore from "@/shared/stores/useThemeStore";

/** Legacy export names, thehope.one forest values. */
export const FAN_CARD_GOLD = "#5e8f72";
export const FAN_CARD_GOLD_LIGHT = "#a8c9b2";
export const FAN_CARD_GOLD_DARK = "#2a5241";
export const FAN_CARD_BACK_BG = "#101c17";
export const FAN_CARD_BACK_SURFACE = "#16261f";

export type FanLogTheme = {
  pageBg: string;
  surface: string;
  headerBg: string;
  border: string;
  gold: string;
  title: string;
  detail: string;
  muted: string;
  eyebrow: string;
  icon: string;
  iconHoverBg: string;
  summaryShadow: string;
  cardShadow: string;
};

export function getFanLogTheme(darkMode: boolean): FanLogTheme {
  if (darkMode) {
    return {
      pageBg: FAN_CARD_BACK_BG,
      surface: FAN_CARD_BACK_SURFACE,
      headerBg: "rgba(16, 28, 23, 0.92)",
      border: FAN_CARD_GOLD_DARK,
      gold: FAN_CARD_GOLD,
      title: "#ffffff",
      detail: "rgba(205, 227, 212, 0.88)",
      muted: "rgba(205, 227, 212, 0.65)",
      eyebrow: "rgba(205, 227, 212, 0.7)",
      icon: FAN_CARD_GOLD_LIGHT,
      iconHoverBg: "rgba(94, 143, 114, 0.14)",
      summaryShadow: "none",
      cardShadow: "none",
    };
  }

  return {
    pageBg: "var(--attic-cream)",
    surface: "var(--attic-paper)",
    headerBg: "rgba(255, 255, 255, 0.92)",
    border: "#bcd9c5",
    gold: "#376b55",
    title: "#102c24",
    detail: "rgba(23, 35, 29, 0.88)",
    muted: "rgba(35, 80, 63, 0.62)",
    eyebrow: "rgba(35, 80, 63, 0.72)",
    icon: "#47765c",
    iconHoverBg: "rgba(94, 143, 114, 0.16)",
    summaryShadow: "0 8px 24px rgba(16, 44, 36, 0.08)",
    cardShadow: "0 4px 14px rgba(16, 44, 36, 0.06)",
  };
}

export function useFanLogTheme(): FanLogTheme {
  const { darkMode } = useThemeStore();
  return useMemo(() => getFanLogTheme(darkMode), [darkMode]);
}

export const fanCardPrimaryButtonSx = {
  borderRadius: "999px",
  px: 3,
  py: 1,
  textTransform: "none",
  fontWeight: 700,
  fontSize: "0.875rem",
  letterSpacing: "0.02em",
  color: FAN_CARD_BACK_BG,
  bgcolor: FAN_CARD_GOLD,
  border: `1px solid ${FAN_CARD_GOLD_DARK}`,
  boxShadow: `inset 0 0 0 1px ${FAN_CARD_GOLD_LIGHT}`,
  "&:hover": {
    bgcolor: FAN_CARD_GOLD_LIGHT,
    borderColor: FAN_CARD_GOLD,
  },
} as const;
